import React from "react";
import {useSite} from "../Providers/SiteInterfaceProvider";
import {DataPreFetcher} from "./DataPreFetcher";
import CreateNewMessageModal from "./MessageCentre/Modals/CreateNewMessageModal";
import PDFViewerModal from "./PDFViewerModal";
import { ServiceAlertManager } from './ServiceAlertManager';

const SiteGlobalComponents = () => {
    const { pDFViewerDetails, siteContactDetails, setPdfViewer, UpdateSiteContact }  = useSite();

    return (
        <>
            <DataPreFetcher />
            <ServiceAlertManager />

            <PDFViewerModal
                isOpen={pDFViewerDetails.open}
                closeCallback={() => setPdfViewer(false)}
            />

            <CreateNewMessageModal
                placeholderMessage={siteContactDetails.placeholderMessage}
                readOnlyMessage={siteContactDetails.readOnlyMessage}
                defaultDepartment={siteContactDetails.departmentId}
                isOpen={siteContactDetails.open}
                closeCallback={() => UpdateSiteContact(false)}
            />
        </>
    )
}

export { SiteGlobalComponents }
